module.exports = __webpack_public_path__ + "static/year2008-affc6cec6d1b028c3911ff02c1ade0c1.jpg";